import MuiAccordion from '@mui/material/Accordion';
import { styled } from '../styled';
export var AccordionComponentName = 'QuantumAcccordion';
export var Accordion = styled(MuiAccordion, {
    name: AccordionComponentName,
    slot: 'Root',
})({
    boxShadow: 'none',
    backgroundImage: 'none',
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    gridColumn: 'span 5',
    '&.Mui-expanded': {
        margin: 0,
    },
    '&:before': {
        top: 0,
    },
});
